<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="editedGroup != undefined"
      :class="{
        opened: opened.indexOf('editGroup') >= 0,
        'last-active': opened.indexOf('editGroup') === opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitRoutovaciSkupinu") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ editedGroup.deviceGroupName }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.device" class="text-danger">
          {{ errors.device }}
        </div>
        <div class="my-4">
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">
              <div class="side-box__content__label__withTooltip">
                <InfoQuestionMark :info-tooltip-text="'tooltip_novaSkupina_nazevSkupiny'" />
                {{ $t("nazevSkupiny") }}
              </div>
            </span>
            <div
              :class="{
                'has-error': errors.device && !editedGroup.deviceGroupName
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <input
                v-model="editedGroup.deviceGroupName"
                :placeholder="$t('zadejteNazevSkupiny')"
                autofocus
                class="w-100"
                maxlength="30"
                minlength="1"
                type="text"
                @click="changedEvent"
              />
            </div>
          </div>
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">
              <div class="side-box__content__label__withTooltip">
                <InfoQuestionMark :info-tooltip-text="'tooltip_novaSkupina_popisSkupiny'" />
                {{ $t("popisSkupiny") }}
              </div>
            </span>
            <div
              :class="{
                'has-error': errors.device && !editedGroup.deviceGroupDesc
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <input
                v-model="editedGroup.deviceGroupDesc"
                :placeholder="$t('zadejtePopisSkupiny')"
                autofocus
                class="w-100"
                maxlength="255"
                type="text"
                @click="changedEvent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <SaveConfirmationModal
      :opened="openedGroupConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupConfirmation"
      @no="closeBox('editGroup')"
      @yes="runEdit"
    />

    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import InfoQuestionMark from "@/components/info/infoQuestionMark.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal,
    InfoQuestionMark
  },
  props: {
    tags: Array,
    opened: Array,
    groupsEndpoints: Array,
    device: Object
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      changed: false,
      protocolOpened: false,
      loadedEndpoints: [],
      selectedEndpoints: [],
      endpointsToUnappend: [],
      groupsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      selectedEndpointTags: [],
      selectedGroupTags: [],
      groupTags: [],
      writtenEndpointTags: "",
      writtenGroupTags: "",
      protocol: "",
      openedGroupConfirmation: false,
      errors: {
        group: ""
      },
      servicesLimitsOpened: false,
      service: {},
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    },
    editedGroup() {
      return Object.assign({}, this.device)
    }
  },
  methods: {
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "editGroup") {
        this.selectedEndpoints = []
        this.endpointsToUnappend = []
        this.resetValues()
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    async runEdit() {
      this.errorsToTranslate = []
      let editGroup = await this.editGroup()

      if (editGroup) {
        this.$emit("reloadItems")

        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
        }
        this.closeBox("editGroup")
        this.selectedEndpoints = []
      }
    },
    async editGroup() {
      if (this.editedGroup.deviceGroupName) {
        return axios
          .put(process.env.VUE_APP_API + "/device-groups/" + this.editedGroup.deviceGroupId, this.editedGroup)
          .then(() => {
            return true
          })
          .catch((error) => {
            this.errorsToTranslate.push(error.data)
            return true
          })
      } else {
        this.errors.device = this.$t("fillAllFieldsError")
      }
    },
    resetValues() {
      this.groupsOpened = false
      this.errors.device = ""
      this.selectedEndpoints = []
      this.actualEndpoints = []
      this.loadedEndpoints = []
      this.newParameters = {}
      this.newAttributes = {}
      this.createdParams = []
    },
    toggleGroupConfirmation() {
      if (this.changed) {
        this.openedGroupConfirmation = !this.openedGroupConfirmation
      } else {
        this.openedGroupConfirmation = false
        this.$emit("closeBox", "editGroup")
      }
    }
  }
}
</script>
